class DataCenterLog {
    static send({
        cmd = 9010,
        item = '',
        action = '',
        pageId = '',
        pos = '',
        uid = ''
    }) {
        let query = []
        let arg = arguments[0] || {}
        let option = {
            cmd,
            item,
            action,
            pageId,
            pos,
            uid,
            ...arg
        }
        for (let key in option) {
            query.push(`${key}=${option[key]}`)
        }
    // new Image().src = path + query.join('&');
    }
}

export default DataCenterLog



// WEBPACK FOOTER //
// ./src/core/DataCenterLog.js